import { render, staticRenderFns } from "./ViewClient.vue?vue&type=template&id=18941390&scoped=true&"
import script from "./ViewClient.vue?vue&type=script&lang=js&"
export * from "./ViewClient.vue?vue&type=script&lang=js&"
import style0 from "./ViewClient.vue?vue&type=style&index=0&id=18941390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18941390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFlex})
